import React from 'react';
import { motion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';
interface ProgressBarProps {
  progress: number; // 0 to 100
  colorClass?: string;
  heightClass?: string;
  className?: string;
  showLabel?: boolean;
}
export function ProgressBar({
  progress,
  colorClass = 'bg-brand-primary',
  heightClass = 'h-2',
  className,
  showLabel = false
}: ProgressBarProps) {
  const clampedProgress = Math.min(Math.max(progress, 0), 100);
  return <div className={twMerge('w-full', className)} data-id="element-55">
      {showLabel && <div className="flex justify-between text-sm mb-1.5" data-id="element-56">
          <span className="text-text-secondary font-medium" data-id="element-57">Progress</span>
          <span className="font-semibold text-text-primary" data-id="element-58">
            {clampedProgress}%
          </span>
        </div>}
      <div className={twMerge('w-full bg-gray-100 rounded-full overflow-hidden', heightClass)} data-id="element-59">
        <motion.div className={twMerge('h-full rounded-full', colorClass)} initial={{
        width: 0
      }} animate={{
        width: `${clampedProgress}%`
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-60" />
      </div>
    </div>;
}